import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Accordion } from "@/components/@common/Accordion";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Icon, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import HandoutCard from "./HandoutCard";
const BrandRankingDropdownItem = (param)=>{
    let { rank , handouts , onViewAllClick , onHandoutClick , onSampleClick , className , authorName , brandName , brandThumbnailUrl , subscriberCount , isOnSale , saleTagText  } = param;
    const { isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs(Accordion.Item, {
        value: "rank-".concat(rank),
        border: "none",
        className: cn("border-b border-gray-200", "data-[state=open]:rounded-lg data-[state=open]:border data-[state=open]:border-gray-700", className),
        children: [
            /*#__PURE__*/ _jsx(Accordion.Trigger, {
                className: "px-3 py-4 max-sm:px-2.5 max-sm:py-2.5",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-5 max-sm:gap-3",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex min-w-[40px] items-center justify-center px-2",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "h3",
                                className: "text-strong tracking-tight",
                                children: rank
                            })
                        }),
                        brandThumbnailUrl && /*#__PURE__*/ _jsx(Image, {
                            src: brandThumbnailUrl,
                            alt: "".concat(authorName, "-thumbnail"),
                            width: isMobile ? 40 : 56,
                            height: isMobile ? 40 : 56,
                            className: "overflow-hidden rounded-full"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col items-start gap-0",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: isMobile ? "subtitle1" : "h6",
                                            className: "text-primary cursor-pointer hover:underline",
                                            children: authorName
                                        }),
                                        isOnSale && /*#__PURE__*/ _jsx(Tag, {
                                            color: "red",
                                            bold: true,
                                            size: isMobile ? "sm" : "md",
                                            children: saleTagText
                                        })
                                    ]
                                }),
                                brandName && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: isMobile ? "body2" : "body1",
                                    className: "text-secondary",
                                    children: [
                                        "구독자 ",
                                        subscriberCount === null || subscriberCount === void 0 ? void 0 : subscriberCount.toLocaleString()
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Accordion.Content, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn("scrollbar-hide flex max-w-[1200px] flex-col items-start gap-7 overflow-x-auto px-5 pt-5 pb-7", "max-sm:px-3 max-sm:pt-3"),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "flex w-full gap-5 max-sm:gap-3 max-sm:pr-3",
                            children: (handouts !== null && handouts !== void 0 ? handouts : []).slice(0, 5).map((handout)=>{
                                /*#__PURE__*/ return _createElement(HandoutCard, {
                                    className: "w-[216px]",
                                    ...handout,
                                    key: handout.productId,
                                    id: handout.productId,
                                    imageUrl: handout.thumbImg,
                                    authorName: authorName,
                                    brandName: brandName,
                                    onCardClick: (e)=>{
                                        e.stopPropagation();
                                        onHandoutClick === null || onHandoutClick === void 0 ? void 0 : onHandoutClick(handout.productId);
                                    },
                                    onSampleClick: ()=>{
                                        return onSampleClick === null || onSampleClick === void 0 ? void 0 : onSampleClick(handout.productId);
                                    }
                                });
                            })
                        })
                    }),
                    brandName && /*#__PURE__*/ _jsx("div", {
                        className: "flex w-full justify-center pb-7 max-sm:px-3 max-sm:pb-3",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            color: "secondary",
                            size: isMobile ? "md" : "lg",
                            rightElement: /*#__PURE__*/ _jsx("div", {
                                className: "h-5 w-5 max-sm:h-[18px] max-sm:w-[18px]",
                                children: /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {})
                            }),
                            className: "w-[360px]",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onViewAllClick === null || onViewAllClick === void 0 ? void 0 : onViewAllClick();
                            },
                            children: "브랜드 자료 전체보기"
                        })
                    })
                ]
            })
        ]
    });
};
export default BrandRankingDropdownItem;
